import { ProductVariant } from 'types/Product';
import { isNotInStock } from 'utilities/util';

export default function allItemsOutOfStock(skus: ProductVariant[]) {
  return !skus?.some((sku) => !isNotInStock(sku?.stock?.code));
}
